AppTabs.createTab( {

name: 'attachments',
icon: 'paperclip',
text: 'Attachments',

create: function(init) {
	'use strict'

	const tab = this;
	const attachmentTab = AppTabs.getTab('attachment');
	init.setController( new TabControllerVue({
		el: '#attachments',
		created() {
			this.ajaxAdjustFilters('client');
		},
		computed: {
			clients: function() {
				return LocalStorageManager.get( 'clientList' );
			},
		},
		methods: {
			resetData() {
				this.client         = null;
				this.projectName    = null;
				this.projectNames   = [];
				this.projectNameId  = null;
				this.projectNumber  = null;
				this.projectNumbers = [];
				this.attachments    = [];
				this.attachmentDir  = '';
				this.fetching       = false;
			},
			ajaxAdjustFilters: function(update, onSuccess = null, onError = null){
				const _this = this;
				_this.fetching = true;
				const data = {
					action:        'adjust_result_filtering',
					update,
					addresses:     false,
					report_emails: false,
					clientId:      this.client ? this.client.id : null,
					projectNumber: this.projectNumber,
				};
				if ( this.projectName !== null )
					data.projectName = this.projectName;
				window.ajaxCall({
					data,
					onSuccess : function( { data } ) {
						_this.lockUpdates( 'ajaxAdjustFilters' );
						if ( 'clientId' in data && ( _this.client == null || _this.client.id != data.clientId ) ) {
							_this.client = ( data.clientId != null && _this.clients
								&& _this.clients.find( client => client.id == data.clientId ) ) || null;
						}
						if ( 'projectName' in data ) {
							_this.projectName = data.projectName;
						}
						if ( 'projectNames' in data ) {
							_this.projectNames = data.projectNames;
							_this.projectName = _this.projectNames
								&& _this.projectNames.find( projectName => projectName == _this.projectName ) || null;
						}
						if ( 'projectNameId' in data ) {
							_this.projectNameId = data.projectNameId;
						}
						if ( 'projectNumber' in data ) {
							_this.projectNumber = data.projectNumber;
						}
						if ( 'projectNumbers' in data ) {
							_this.projectNumbers = data.projectNumbers;
							if ( _this.client )
								_this.projectNumber = _this.projectNumbers
									&& _this.projectNumbers.find( projectNumber => projectNumber == _this.projectNumber ) || null;
						}
						_this.unlockUpdatesLater( 'ajaxAdjustFilters', onSuccess );
						_this.fetching = false;
						if ( _this.projectNumber );
							_this.processAttachmentsForm( new FormData() );
					},
					onError : function( response ) {
						_this.fetching = false;
						alert( 'Could not update filters' );
						typeof onError == 'function' && onError();
					},
				});
			},

			requestFile: function( event ) {
				let target = event.target;
				// ignore click on file input itself
				if ( target.type === 'file' ) { return; }
				while ( target ) {
					const fileInput = Array.prototype.find.call( target.getElementsByTagName('input'), input => input.type == 'file' );
					if ( fileInput ) {
						fileInput.click();
						return;
					}
					target = target.parentElement;
				}
			},
			upload: function( event ) {
				const input = event.target;
				if ( input.files.length == 0 ) { return }
				console.log( input.files );
				const formData = new FormData();
				for (let i = 0; i < input.files.length; i++) {
					formData.append( 'attachments[]', input.files[i] );
				}

				this.processAttachmentsForm(formData);
			},
			processAttachmentsForm: function(formData) {
				formData.append( 'JobNumber', this.projectNumber );
				formData.append( 'session_id', ajax_object.session_id );
				formData.append( 'action', 'attach_to_job' );
				const _this = this;
				jQuery.ajax( ajax_object.ajax_url, {
					method: 'POST',
					data: formData,
					processData: false,
					contentType: false,
					success: function( response ) {
						_this._data.attachments = response.data.attachments;
					},
					error: function(error) {
						console.error( 'Error:', error );
					},
				} );
			},
			openAttachment: function(attachment) {
				attachmentTab.controller.OpenAttachment(this.projectNumber, attachment);
			},
			removeAttachment: function(attachment) {
				const _this = this;
				window.ConfirmationModalManager.show({
					title: 'Delete Attachment: ' + attachment,
					message: 'Are you sure you want to permanently delete "' + attachment + '" from project #' + this.projectNumber + '?',
					buttonText: 'Delete',
					callback: function() {
						const formData = new FormData();
						formData.append( 'remove[]', attachment );
						_this.processAttachmentsForm(formData);
					},
				});
			},
		},
		watch: {
			client: function( newValue, oldValue ) {
				if ( newValue == oldValue || ( newValue && oldValue && newValue.id == oldValue.id ) ) { return; }
				if ( this.getUpdateLockLevel() ) { return; }
				this.ajaxAdjustFilters( 'client' );
			},
			projectName: function( value, oldValue ) {
				if ( value == oldValue || this.getUpdateLockLevel() ) { return; }
				this.ajaxAdjustFilters( 'projectName' );
			},
			projectNumber: function( value, oldValue ) {
				if ( value == oldValue || this.getUpdateLockLevel() ) { return; }
				this.ajaxAdjustFilters( 'project' );
			},
		}
	}) );

}

} );
